// FramedMiles — arrow nav for product gallery
(function () {
  function initGalleryNav(gallery) {
    var viewer   = gallery.querySelector('[id^="GalleryViewer-"]');
    var thumbBox = gallery.querySelector('[id^="GalleryThumbnails-"]');
    if (!viewer || !thumbBox) return;

    var prevBtn = viewer.querySelector('.slider-button--prev');
    var nextBtn = viewer.querySelector('.slider-button--next');
    if (!prevBtn || !nextBtn) return;

    // All thumb li elements in order
    function thumbLis() {
      return Array.from(thumbBox.querySelectorAll('li[data-target]'));
    }

    // Find currently active thumb index by matching GalleryViewer's active slide
    function activeThumbIndex(lis) {
      var activeSlide = viewer.querySelector('.product__media-item.is-active[data-media-id]');
      if (!activeSlide) return 0;
      var mediaId = activeSlide.dataset.mediaId;
      var idx = lis.findIndex(function(li){ return li.dataset.target === mediaId; });
      return idx >= 0 ? idx : 0;
    }

    function clickThumb(li) {
      var btn = li && li.querySelector('button');
      if (btn) btn.click();
    }

    prevBtn.addEventListener('click', function (e) {
      e.stopImmediatePropagation();
      var lis = thumbLis();
      var idx = activeThumbIndex(lis);
      clickThumb(lis[idx <= 0 ? lis.length - 1 : idx - 1]);
    }, true); // capture phase — runs before Dawn's slider handler

    nextBtn.addEventListener('click', function (e) {
      e.stopImmediatePropagation();
      var lis = thumbLis();
      var idx = activeThumbIndex(lis);
      clickThumb(lis[idx >= lis.length - 1 ? 0 : idx + 1]);
    }, true); // capture phase
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(initGalleryNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
